import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import { createStore } from 'satcheljs';
var initialReadingPaneStore = {
    conversationReadingPaneViewState: null,
    itemReadingPaneViewState: null,
    itemPreviewPaneViewState: null,
    itemPrintPaneViewState: null,
    deeplinkId: null,
};
export var getStore = createStore('readingpane', initialReadingPaneStore);
var store = getStore();
// Register the reading pane conversation with the conversation cache
conversationCache.registerReference(function () {
    return store.conversationReadingPaneViewState &&
        store.conversationReadingPaneViewState.conversationId.Id;
});
export default store;
//# sourceMappingURL=Store.js.map